module.exports = __webpack_public_path__ + "static/media/adult3.8383a2ef.jpg";